module.exports = __webpack_public_path__ + "static/media/pic8.3064fb76.jpg";